import CustomCheckbox from "@src/components/CustomCheckbox";

export function HasMobileAppComponent(record) {
  return (props) => {
    return (
      <CustomCheckbox
        id="ticketRestaurant-mangeMyCards-activeCardlist-hasMobileAppComponent-checkbox"
        disabled={!record?.mobileAppUserId}
        {...props}
      />
    );
  };
}